import { LoginApi, RegistrationApi } from "@/api";
import i18n from "@/i18n";
import { showSuccessSnackbar } from "@/utilities/snackbar";

export async function createUser(firmId, data) {
  await RegistrationApi.createUser(firmId, data);
  showSuccessSnackbar(
    200,
    `${i18n.t("email-sent-pt-1")} "${data.email}" ${i18n.t("email-sent-pt-2")}`
  );
}

export async function validateToken(token, newPassword) {
  await LoginApi.validateRegistrationToken(token, newPassword);
  showSuccessSnackbar(200, i18n.t("registration-success"));
}
